import React, { Component } from 'react';

export default class screen extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div style={{ margin: '40px' }}>
        <div className='policies'>
          <h1>Terms of use</h1>
        </div>
        <p>By checking below you agree that the Prep2Pass service including the Prep2Pass product, graphics, user
          interface, editorial content, and software used to implement the Prep2Pass app contains proprietary
          information and proprietary and material that is owned by Prep2Pass LLC and / or licensors, and it is
          protected by applicable intellectual property and other laws, including but not limited to copyright. You
          agree that you will not use such proprietary information or materials in any way whatsoever except for the use
          of the Prep2Pass service in compliance with this Agreement. No portion of the Prep2Pass service may be
          reproduced in any form or by any means, except as expressly permitted in these terms. You agree not to modify,
          rent, lease, loan, sell, distribute, or create derivative works based on the Prep2Pass service in any manner,
          and you shall not exploit the Prep2Pass service in any unauthorized way whatsoever, including, but not limited
          to, but trespass or burdening network capacity.</p>
        <p>We are committed to your satisfaction. Because of the nature of digital sales, all product content is
          available immediately and all sales are final. Contact us at <a
            href={'mailto:support@diehl1.com'}
          >support@diehl1.com</a> for any questions or assistance.</p>

      </div>
    );
  }
}
